import { render } from "./Pronostico.vue?vue&type=template&id=5ec6bfc2"
import script from "./Pronostico.vue?vue&type=script&lang=js"
export * from "./Pronostico.vue?vue&type=script&lang=js"

import "./Pronostico.vue?vue&type=style&index=0&id=5ec6bfc2&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__